import { schema } from 'normalizr';

export const part = new schema.Entity(
  'parts',
  {},
  {
    idAttribute: 'uuid',
  },
);

export const parts = [part];
